import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

const app = createApp(App);
app.config.performance = false;

// 팝업 -> 부모 컴포넌트 요청
window.goIntroDunsFromPopup = function () { router.push('/apply-duns'); };

createApp(App).use(store).use(router).mount("#app");
